import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { ROUTES } from '~/utils/routes';
import { useStressAssessmentUserReportList } from './hooks';
import { convertToPresentationProps } from './logics';
import { StressAssessmentUserReportListPresentation } from './presentations';

type Props = {
  stressAssessmentId: number;
};

export const StressAssessmentUserReportList: React.FC<Props> = ({ stressAssessmentId }) => {
  const { enableStaging } = getEnvFeatureFlag();

  const {
    state: {
      role,
      userReportList,
      summary,
      filter,
      isOpenRemindModal,
      threeLetterCode,
      currentPage,
      totalPage,
      totalCount,
    },
    actions: {
      handleFilterChange,
      handlePageChange,
      handleOpenRemindModal,
      handleCloseRemindModal,
      handleRowClick,
    },
  } = useStressAssessmentUserReportList({ stressAssessmentId, skipRoleCookie: enableStaging });

  if (!role) return null;

  const { users, tabItems, showInterviewGuidanceInquiryAlert } = convertToPresentationProps({
    userReportList,
    summary,
    role,
  });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: users,
    onPageChange: handlePageChange,
  });

  return (
    <StressAssessmentUserReportListPresentation
      role={role}
      selectedTabValue={filter}
      tabItems={tabItems}
      users={users}
      pagerProps={pagerProps}
      isOpenRemindModal={isOpenRemindModal}
      threeLetterCode={threeLetterCode}
      stressAssessmentId={stressAssessmentId}
      showInterviewGuidanceInquiryAlert={enableStaging && showInterviewGuidanceInquiryAlert}
      inquiryFormUrl={ROUTES.STRESS_ASSESSMENT_IMPLEMENTER_INQUIRY_FORM}
      onFilterChange={handleFilterChange}
      onOpenRemindModal={handleOpenRemindModal}
      onCloseRemindModal={handleCloseRemindModal}
      onRowClick={role === 'implementer' ? handleRowClick : undefined}
    />
  );
};
